class Location {
  constructor(v) {
    this.id = v.id;
    this.name = v.name;
    this.enemies = v.enemies;
    this.drops = v.drops;
    this.lootTable = v.lootTable;
  }
}

export default Location;
